export const authEndpoint: string = "https://api.brianhung.info/auth";
export const graphqlEndpoint: string = "api.brianhung.info/hasura/v1/graphql";
